<template>
  <div class="store">
    <navBar></navBar>
    <div class="shop-wrapper">
      <store-top :shopData="shopData"></store-top>
    </div>
    <div class="info-wrapper">
      <div class="info">
        <!-- :style="{
          background: shopData.BackgroundColorCode,
          color: shopData.CharacterColorCode
        }" -->
        <div class="userImg">
          <img class="userImgIcon" :src="imgUrlFilter(shopData.CompanyLogo)"
            @click="imagePreview(imgUrlFilter(shopData.CompanyLogo))" />
        </div>
        <div class="company">
          <div class="companyTitle">{{ shopData.CompanyName }}</div>
          <div class="companySubTitle">
            {{ shopData.BusinessProductClassList }}
          </div>
        </div>
        <div class="last-date">
          <div class="left">{{ $t("business.lastUpdate") }}</div>
          <div class="right">{{ shopData.LastUpdated }}</div>
        </div>
        <div class="profile">
          <div class="left">{{ $t("business.profile") }}</div>
          <div class="right long-text" :class="{ expanded: isTextExpanded }" ref="longText">{{ shopData.CompanyProfile
            }}</div>
          <div class="btns" v-if="showFoldBtn">
            <el-button type="text" size="mini" @click="toggleFold">{{
              isTextExpanded ? $t("business.collapse") : $t("business.expand")
              }}</el-button>
          </div>
        </div>
        <div class="buttons">
          <div class="right">
            <el-button class="basket-button" type="primary" size="small" @click="toBasket" v-if="!isAdmin"><i
                class="el-icon-plus"></i><span>{{ $t("B2B.toBasket") }}</span></el-button>
            <el-button type="warning" size="small" class="quiry-button" @click="toEnquiry" v-if="!isAdmin">{{
              $t("B2B.inquiry") }}</el-button>
            <el-button type="primary" size="small" @click="toEdit" v-if="isAdmin">{{ $t("business.createCommodity")
              }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="product-wrapper">
      <div class="searchBox">
        <div class="searchInfo">
          <input class="searchInoput" :placeholder="$t('business.searchInside')" v-model="sreachValues"
            @keyup.enter="updateTabNav('second', true)" />
          <div class="searchLogo" @click="updateTabNav('second', true)">
            <img class="searchLogoIcon" src="~assets/img/store/icon_home_search@2x.png" />
          </div>
        </div>
      </div>
      <tabPane :tab-list="tabNav" :active="activeTab" class="m-20" @updateActive="updateTabNav">
        <div slot="first">
          <home-goods @setCategory="setCategory" @toDelete="toDelete" @setState="setState" @setShowcase="setShowcase"
            :businessClassList="shopData.BusinessClassList" :productShowcaseList="shopData.ProductShowcaseList"
            :isAdmin="isAdmin" />
        </div>
        <div slot="second">
          <div class="filters">
            <div class="filters-title">{{ $t("business.sort") }}</div>
            <el-select v-model="orderBy" :placeholder="$t('B2B.select')" clearable size="small" @change="getList"
              style="margin-right:30px;">
              <el-option v-for="item in orderByOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>

            <div class="filters-title">{{ $t("business.selection") }}</div>
            <el-select v-model="showcase" :placeholder="$t('B2B.select')" clearable size="small" @change="getList"
              style="width:10%;margin-right:30px;">
              <el-option v-for="item in showcaseOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>

            <div class="filters-title" v-if="isAdmin">
              {{ $t("business.state") }}
            </div>
            <el-select v-model="state" :placeholder="$t('B2B.select')" clearable size="small" @change="getList"
              class="m-l-30" style="width:10%;" v-if="isAdmin">
              <el-option v-for="item in stateOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>

            <div class="filters-category" v-if="category && category.value">
              <el-tag closable @close="onCloseCategory">{{
                category.name
                }}</el-tag>
            </div>
          </div>
          <all-goods @getData="getData" @toDelete="toDelete" @setState="setState" :productList="productList"
            :isAdmin="isAdmin" :totalCount="totalCount" />
        </div>
      </tabPane>
    </div>

    <basket v-if="!isAdmin"></basket>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { SET_BASKET } from "../../store/mutation-types";

import StoreTop from "./components/StoreTop";
import HomeGoods from "./components/HomeGoods";
import AllGoods from "./components/AllGoods";
import tabPane from "./components/tabPane.vue";

export default {
  name: "Business",
  components: {
    StoreTop,
    HomeGoods,
    AllGoods,
    tabPane
  },
  data() {
    return {
      activeTab: "first",
      tabNav: [
        {
          label: this.$t("business.tab1"),
          name: "first"
        },
        {
          label: this.$t("business.tab2"),
          name: "second"
        }
      ],
      orderByOptions: [
        {
          label: this.$t("business.orderBy1"),
          value: 1
        },
        {
          label: this.$t("business.orderBy2"),
          value: 2
        }
      ],
      stateOptions: [
        {
          label: this.$t("business.state1"),
          value: 1
        },
        {
          label: this.$t("business.state2"),
          value: 0
        }
      ],
      showcaseOptions: [
        {
          label: this.$t("business.yes"),
          value: 1
        },
        {
          label: this.$t("business.no"),
          value: 0
        }
      ],
      shopId: "",
      isAdmin: false,
      sreachValues: "",
      orderBy: 1,
      state: null,
      showcase: null,
      category: {
        name: "",
        value: ""
      },
      pageIndex: 1,
      pageSize: 20,
      totalCount: 1,
      shopData: {},
      productList: [],
      isTextExpanded: false,
      showFoldBtn: false
    };
  },
  computed: {
    ...mapState({
      supplierInfo: state => state.supplier.supplierInfo
    })
  },
  mounted() {
    const { ShopId, IsAdmin } = this.$route.query;
    this.shopId = ShopId;
    this.isAdmin = IsAdmin;
    this.getSupplierShopHomePage();
  },
  methods: {
    ...mapMutations([SET_BASKET]),
    ...mapActions({ getBasketProducts: "getBasket" }),
    toggleFold() {
      this.isTextExpanded = !this.isTextExpanded;
    },
    measureProfile() {
      this.$nextTick(() => {
        var longText = this.$refs.longText;
        if (!longText) return;
        // 收起时按 5 行截断（-webkit-line-clamp）；
        // 内容完整高度超过截断高度，说明超出 5 行，才显示展开按钮
        var clampedHeight = longText.clientHeight;
        longText.style.display = "block";
        var fullHeight = longText.scrollHeight;
        longText.style.display = "";
        this.showFoldBtn = fullHeight > clampedHeight + 2;
        if (!this.showFoldBtn) {
          this.isTextExpanded = false;
        }
      });
    },
    toBasket() {
      var supplier = {
        ShopId: this.shopData.ShopId,
        CompanyName: this.shopData.CompanyName,
        CompanyLogo: this.shopData.CompanyLogo
      };
      this.getBasketProducts().then(res => {
        var prduct = res.suppliers.find(p => p.ShopId == this.shopData.ShopId);
        if (prduct) {
          this.$message.error(this.$t("B2B.repeat"));
        } else {
          this.$message.success(this.$t("B2B.addSuccess"));
          this.$bus.$emit("showBasket", { show: true, activeTab: "second" });
        }
        this.SET_BASKET({ supplier: supplier, type: 2 });
      });
    },
    toEnquiry() {
      let routeUrl = this.$router.resolve({
        path: "/enquiry",
        query: { ShopIdList: this.shopId }
      });
      window.open(routeUrl.href, "_blank");
    },
    onCloseCategory() {
      this.category = {
        name: "",
        value: ""
      };
      this.getList();
    },
    updateTabNav(val, isChange) {
      this.activeTab = val;
      if (isChange) {
        this.$bus.$emit("changeTab", val);
      }
      this.getList();
    },
    getList() {
      switch (this.activeTab) {
        case "first":
          this.getSupplierShopHomePage();
          break;
        case "second":
          this.getProductSearchList();
          break;
      }
    },
    getData(data) {
      this.pageIndex = data.pageIndex;
      this.pageSize = data.pageSize;
      this.getList();
    },
    toEdit() {
      this.$router.push("/commodityEdit");
    },
    getSupplierShopHomePage() {
      let param = {
        ShopId: this.shopId,
        IsAdminUserAccess: this.isAdmin ? 1 : 0
      };
      this.$api.customer
        .getSupplierShopHomePage(param)
        .then(res => {
          this.shopData = res.data;
          this.measureProfile();
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    getProductSearchList() {
      let param = {
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        ShopId: this.shopId,
        IsAdminUserAccess: this.isAdmin ? 1 : 0,
        IsSearchProductShowcase: this.showcase,
        BPCId: this.category.value,
        ProductOrderBy: this.orderBy,
        ProductState: this.state,
        ProductKeywords: this.sreachValues
      };
      this.$api.product
        .getProductSearchList(param)
        .then(res => {
          this.productList = res.data;
          this.totalCount = res.meta.total;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    setShowcase() {
      this.showcase = 1;
      this.updateTabNav("second", true);
    },
    setCategory(name, id) {
      this.category.name = name;
      this.category.value = id;
      this.updateTabNav("second", true);
    },
    toDelete(productNumber) {
      let param = {
        PId: productNumber
      };
      this.$api.product
        .deleteSupplierProductInfo(param)
        .then(() => {
          this.getList();
          this.$message.success(this.$t("business.delete"));
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    setState(productNumber, state) {
      let param = {
        PId: productNumber,
        ProductState: state
      };
      this.$api.product
        .setProductState(param)
        .then(() => {
          this.getList();
          this.$message.success(this.$t("B2B.success"));
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(image) {
      window.open(image);
    }
  }
};
</script>
<style lang="scss" scoped>
.store {
  padding-bottom: 10%;

  .shop-wrapper {
    width: 100%;
    margin: auto;
  }

  .info-wrapper {
    width: 25%;
    display: inline-block;
    padding: 30px;
    margin-left: 10%;

    .info {
      padding: 30px;
      border-radius: 5px;
      box-shadow: 0 0 5px 0px #9b9b9b;

      .userImg {
        width: 30%;
        display: inline-block;
        text-align: center;
        vertical-align: middle;

        .userImgIcon {
          width: 80px;
          height: 80px;
          border-radius: 100px;
          box-shadow: 0 0 5px 0px #9b9b9b;
          object-fit: cover;
        }
      }

      .company {
        width: 65%;
        margin-left: 5%;
        display: inline-block;
        vertical-align: middle;

        .companyTitle {
          margin: 0;
          padding: 0;
          font-size: 16px;
          width: 100%;
          font-weight: bold;
        }

        .companySubTitle {
          margin: 0;
          padding: 0;
          margin-top: 10px;
          font-size: 14px;
          width: 100%;
          overflow: hidden;
          word-break: break-all;
        }
      }

      .last-date {
        width: 90%;
        margin: 30px auto 0px auto;
        font-size: 14px;

        .left {
          width: 50%;
          display: inline-block;
          vertical-align: middle;
          color: #a7a7a7;
        }

        .right {
          width: 50%;
          display: inline-block;
          vertical-align: middle;
          text-align: right;
        }
      }

      .profile {
        width: 90%;
        margin: 30px auto 0px auto;
        font-size: 14px;

        .left {
          display: inline-block;
          vertical-align: top;
          color: #a7a7a7;
          margin-bottom: 10px;
        }

        .right {
          display: inline-block;
          vertical-align: top;
        }

        .btns {
          text-align: right;

          .el-button--text {
            font-size: 14px !important;
          }
        }

        .long-text {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          overflow: hidden;

          &.expanded {
            display: block;
          }
        }
      }

      .buttons {
        width: 90%;
        margin: 30px auto 0px auto;
        font-size: 14px;

        .right {
          width: 100%;
          display: inline-block;
          vertical-align: middle;
          text-align: right;

          .basket-button {
            vertical-align: middle;
            display: inline-block;
            font-size: 14px;
            background: transparent;
            color: #999;
            border: none;
            margin-right: 10px;
          }

          .quiry-button {
            vertical-align: middle;
            display: inline-block;
            margin: 0;
            font-size: 14px;
            border-radius: 10px;
            padding: 10px 30px;
            background: linear-gradient(270.13deg,
                #f58603 0.13%,
                #fb3f04 99.91%);
          }
        }
      }
    }
  }

  .product-wrapper {
    width: 50%;
    display: inline-block;
    padding: 30px;
    vertical-align: top;

    .filters {
      .filters-title {
        font-weight: bold;
        font-size: 14px;
        color: #01aaa3;
        margin-right: 30px;
        display: inline-block;
      }

      .filters-category {
        margin-left: 30px;
        display: inline-block;
      }
    }

    .searchBox {
      width: 100%;
      margin-bottom: 30px;
      text-align: right;

      .searchInfo {
        width: 30%;
        padding: 8px 20px;
        border: 2px solid #a7a7a7;
        display: inline-block;
        border-radius: 100px;

        .searchInoput {
          outline: none;
          padding: 0;
          width: 90%;
          border: none;
          background-color: #ffffff;
          font-size: 14px;
          color: #a7a7a7;
          vertical-align: middle;
        }

        .searchLogo {
          margin: 0;
          padding: 0;
          width: 10%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
          cursor: pointer;

          .searchLogoIcon {
            width: 20px;
            height: 20px;
            object-fit: cover;
            -webkit-object-fit: cover;
            // background-color: #434343;
          }
        }
      }
    }

    .allGoods {
      min-height: 200px;
    }
  }
}
</style>
